export const Constant = {
	Binding: {
		ONEWAY: "<",
		TWOWAY: "=",
		EVENT: "&",
		VALUE: "@"
	},
	CtrlAs: "vm",
	Event: {
		WindowResized: "WindowResized",
		StateChangedSucess: "StateChangedSucess",
        MasonryLayout: "masonry.layout",
        CompanyListUpdate: "companylist:updated",
        SNRsearchFieldUpdated: "snrSearchField:updated",
        ChangePasswordFormSubmit: "ChangePasswordFormSubmit",
	},
	DateTimeFormat: {
		GMT: 'date:"yyyy-MM-dd hh:mm:ss a (' + "'GMT'" + ')"',
		LOCAL: 'date:"yyyy-MM-dd hh:mm:ss a"',
		EMEADATE: 'date:"dd-MM-yyyy hh:mm:ss a"',
		LOCALNM: 'yyyy-MM-dd hh:mm:ss a',
		EMEADATENM: 'dd-MM-yyyy hh:mm:ss a',
        LOCALWITHOUTSECS: 'date:"yyyy-MM-dd hh:mm a"'
	},
	TextPattern: /^[^\d|^\\//[\]`,-@!+|#$%^&*;:<>?~(){}=\""\_'](A-Z|a-z|0-9)*[^\\//[\]`@!+|$%^&*:<>?~(){}=\""]*$/,
    EmailPattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
	NamePattern: /^[a-zA-Z ˆŠŒŽ–—šœžŸ ¡¨´·¸ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ]+$/,
    MinimumVisibleDataLength: 25,    
	GridPageSize: 100
}